<template>
  <div class="wc-tab">
    <load-state :state="state" empty-text="暂无积分榜" @retry="load(false)">
      <div v-for="group in groups" :key="group.team_group" class="wc-group-card">
        <div class="wc-group-card__title">
          <span class="wc-group-card__letter">{{ group.team_group }}</span>
          <span class="wc-group-card__word">组</span>
        </div>
        <rank-table :teams="sortedTeams(group.team_rank)" />
      </div>
    </load-state>
  </div>
</template>

<script>
import { getRank } from '@/api/worldcup2026'
import LoadState from '../components/LoadState.vue'
import RankTable from '../components/RankTable.vue'
import { worldcupCache } from '../utils/cache'

export default {
  name: 'WorldCupRankTab',
  components: { LoadState, RankTable },
  data () {
    return {
      state: 'idle',
      groups: []
    }
  },
  created () {
    this.load(true)
  },
  methods: {
    async load (useCache = true) {
      if (useCache && worldcupCache.rank) {
        this.applyRank(worldcupCache.rank)
        return
      }
      this.state = 'loading'
      try {
        const resp = await getRank()
        if (resp.error_code !== 0) {
          this.state = 'error'
          return
        }
        const groups = resp.result && resp.result.data ? resp.result.data : []
        worldcupCache.rank = groups
        this.applyRank(groups)
      } catch (e) {
        this.state = 'error'
      }
    },
    applyRank (groups) {
      this.groups = groups
      this.state = groups.length ? 'success' : 'empty'
    },
    sortedTeams (teams) {
      return [...(teams || [])].sort((a, b) => Number(a.rank || 0) - Number(b.rank || 0))
    }
  }
}
</script>

<style scoped lang="scss">
.wc-tab {
  padding: 6px;
}

.wc-group-card {
  box-sizing: border-box;
  margin-bottom: 12px;
  border: 1px solid #dce1eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.wc-group-card__title {
  box-sizing: border-box;
  display: flex;
  align-items: baseline;
  gap: 3px;
  height: 43px;
  padding: 10px 16px 8px;
  border-bottom: 1px solid #dce1eb;
  background: #f0f2f7;
}

.wc-group-card__letter {
  color: #deba40;
  font-size: 22px;
  line-height: 22px;
  font-weight: 900;
}

.wc-group-card__word {
  color: #4a5568;
  font-size: 13px;
  line-height: normal;
  font-weight: 400;
}
</style>
